<template>
  <div class="page" v-loading="loading">
    <el-form ref="form" :model="form" label-width="100px">
      <el-row>
        <el-col :span="6">
          <el-form-item label="仓库名" prop="stockName">
            <el-input v-model="form.stockName"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item>
            <el-button type="primary" @click="getData">查询</el-button>
            <el-button @click="resetForm">重置</el-button>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label-width="0">
        <toolbar :buttonList="buttonList_toolBar" @callFunction="callFunction"></toolbar>
      </el-form-item>
    </el-form>
    <el-table :data="tableData" border style="width: 100%;" :header-cell-style="{ 'text-align': 'center' }"
      :cell-style="{ 'text-align': 'center' }">
      <el-table-column label="id" prop="id" width="200"></el-table-column>
      <el-table-column label="仓库名" prop="stockName" width="200"></el-table-column>
      <el-table-column label="发货区域" prop="deliverAreaName"></el-table-column>
      <el-table-column label="操作" width="430">
        <template slot-scope="scope">
          <el-button size="mini" v-for="(item, index) in buttonList_table" :key="index" :type="item.buttonType"
            @click="callFunctionRow(item, index, scope.row)">{{ item.displayName }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="pagination" @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page="form.pageIndex" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="form.pageSize"
      layout="total, sizes, prev, pager, next, jumper" :total="total">
    </el-pagination>
    <el-dialog :title="addParams.id ? '新建仓库' : '编辑仓库'" :visible.sync="addVisible" width="50%" v-loading="loading">
      <el-form :model="addParams" ref="addParams" label-width="100px">
        <el-form-item label="仓库名" prop="stockName" :rules="[
          { required: true, message: '请输入', trigger: 'blur' },
        ]">
          <el-input v-model="addParams.stockName"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="addVisible = false">取 消</el-button>
        <el-button type="primary" @click="addConfirm">确 定</el-button>
      </span>
    </el-dialog>
    <UploadFile ref="UploadFile" @confirm="uploadFileConfirm" />
    <el-dialog title="发货区域配置" :visible.sync="areaVisible" width="50%" :close-on-click-modal="false">
      <AreaSetting :id="areaParams.id" v-if="areaVisible" :areaStr="areaParams.deliverArea"></AreaSetting>
    </el-dialog>
  </div>
</template>

<script>
import {
  KSAXApiRequest,
  KSAXApiUpload,
} from "../../api/api";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import AreaSetting from "./components/AreaSetting.vue";
import UploadFile from "./components/UploadFile.vue"

export default {
  components: { Toolbar, AreaSetting, UploadFile },
  data() {
    return {
      loading: false,
      tableData: [],
      total: 0,
      buttonList_toolBar: [],
      buttonList_table: [],
      form: {
        level: 2,
        supId: this.$route.query.supId,
        parentId: this.$route.query.id,
        stockName: null,
        pageIndex: 1,
        pageSize: 10
      },
      addVisible: false,
      addParams: {},
      areaVisible: false,
      areaParams: {},
    };
  },
  created() {
    this.queryData()
    let routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : [];
    var buttonList = getButtonList(this.$route.path, routers) || []
    this.buttonList_toolBar = buttonList.filter(item => item.buttonShow === 10);
    this.buttonList_table = buttonList.filter(item => item.buttonShow === 20);
  },
  methods: {
    queryData() {
      this.loading = true
      KSAXApiRequest({
        path: 'Product_MultistageStock/List',
        parmsJson: this.form
      }).then(res => {
        if (res.data.success) {
          this.tableData = res.data.response.data || []
          this.total = res.data.response.dataCount
        } else {
          this.$message.error(res.data.msg)
        }
        setTimeout(() => {
          this.loading = false
        }, 500)
      })
    },
    callFunction(item) {
      this[item.buttonFunc](item);
    },
    callFunctionRow(item, index, row) {
      this[item.buttonFunc](item, index, row);
    },
    getData() {
      this.form.pageIndex = 1
      this.form.pageSize = 10
      this.queryData()
    },
    handleSizeChange(value) {
      this.form.pageSize = value
      this.queryData()
    },
    handleCurrentChange(value) {
      this.form.pageIndex = value
      this.queryData()
    },
    resetForm() {
      this.$refs["form"].resetFields();
      this.getData()
    },
    handleAdd() {
      this.addParams = {
        level: 2,
        stockName: null,
        supIds: this.form.supId,
        parentId: this.$route.query.id,
      }
      this.addVisible = true
    },
    addConfirm() {
      this.$refs.addParams.validate((valid) => {
        if (valid) {
          this.loading = true
          let path = this.addParams.id ? "Product_MultistageStock/Update" : 'Product_MultistageStock/Add'
          KSAXApiRequest({
            path,
            parmsJson: this.addParams,
          }).then(res => {
            this.loading = false
            if (res.data.success) {
              this.$message.success(res.data.msg)
              this.queryData()
              this.addVisible = false
            } else {
              this.$message.error(res.data.msg)
            }
          })
        }
      });
    },
    exportList() {
      KSAXApiRequest({
        path: 'Product_MultistageStock/ExportList',
        parmsJson: this.form
      }).then(res => {
        if (res.data.success) {
          this.$message.success("操作成功，请点击下载中心查看下载结果");
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    areaConfig(item, index, row) {
      this.areaParams = {
        id: row.id,
        deliverArea: row.deliverArea
      }
      this.areaVisible = true
    },
    stock3(item, index, row) {
      this.$router.push(`/MultistageStoc/Config3?id=${row.id}&supId=${row.supIds}`)
    },
    handleDelete(item, index, row) {
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        KSAXApiRequest({
          path: "Product_MultistageStock/Delete",
          parmsJson: { id: row.id },
        }).then(res => {
          this.loading = false
          if (res.data.success) {
            this.$message.success(res.data.msg)
            this.queryData()
          } else {
            this.$message.error(res.data.msg)
          }
        })
      })
    },
    handleEdit(item, index, row) {
      this.addParams = {
        id: row.id,
        stockName: row.stockName,
        supIds: row.supIds,
      }
      this.addVisible = true
    },
    importMultistageStock() {
      this.$refs.UploadFile.init(
        "导入",
        "https://homeimage.ksaxshop.com/%E5%AF%BC%E5%85%A5%E5%A4%9A%E7%BA%A7%E4%BB%93%E6%A8%A1%E6%9D%BF.xlsx"
      )
    },
    uploadFileConfirm(file) {
      if (!file) {
        return this.$message.warning('请上传文件');
      }
      let formData = new window.FormData();
      formData.append("file", file);
      KSAXApiUpload(formData).then((res) => {
        KSAXApiRequest({
          path: "Product_MultistageStock/ImportMultistageStock",
          parmsJson: res.data.slice(1)
        }).then(res => {
          if (res.data.success) {
            this.$message.success(res.data.msg);
            this.$refs.UploadFile.dialogVisible = false
            this.queryData()
          } else {
            this.$message.error(res.data.msg)
          }
        })
      })
    }
  },
};
</script>

<style scoped></style>
